import { configureStore, createSlice } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import wishlistReducer from '../../features/wishlist/store/wishlistSlice';
import dashboardReducer from './slices/dashboardSlice';
import companyReducer from './slices/companySlice'; // ✅ Add this import
import authReducer from './slices/authSlice'; // ✅ Add this import

const initialCustomerState = { customers: [] };
const initialProductState = { products: [] };
const initialInvoiceState = {
  selectedCustomer: null,
  selectedProduct: null,
  quantity: 1,
  price: '',
  vat: 0,
  customText: '',
};

const customerSlice = createSlice({
  name: 'customer',
  initialState: initialCustomerState,
  reducers: {
    setCustomers(state, action) {
      state.customers = action.payload;
    },
  },
});

const productSlice = createSlice({
  name: 'product',
  initialState: initialProductState,
  reducers: {
    setProducts(state, action) {
      state.products = action.payload;
    },
  },
});

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState: initialInvoiceState,
  reducers: {
    setSelectedCustomer(state, action) {
      state.selectedCustomer = action.payload;
    },
    setSelectedProduct(state, action) {
      state.selectedProduct = action.payload;
    },
    setQuantity(state, action) {
      state.quantity = action.payload;
    },
    setPrice(state, action) {
      state.price = action.payload;
    },
    setVat(state, action) {
      state.vat = action.payload;
    },
    setCustomText(state, action) {
      state.customText = action.payload;
    },
  },
});

export const { setCustomers } = customerSlice.actions;
export const { setProducts } = productSlice.actions;
export const {
  setSelectedCustomer,
  setSelectedProduct,
  setQuantity,
  setPrice,
  setVat,
  setCustomText,
} = invoiceSlice.actions;

const rootReducer = combineReducers({
  customer: customerSlice.reducer,
  product: productSlice.reducer,
  invoice: invoiceSlice.reducer,
  wishlist: wishlistReducer,
  dashboard: dashboardReducer,
  company: companyReducer, // ✅ Add company reducer
  auth: authReducer, // ✅ Add auth reducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;